import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    recipientsContainer: {
      marginTop: theme.spacing(1),
    },
    dialogContent: {
      maxWidth: '748px',
    },
    dialogActions: {
      justifyContent: 'space-between',
    },
    dialogError: {
      marginLeft: theme.spacing(2),
    },
    accordionError: {
      color: theme.palette.error.main,
    },
  };
};
